if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("video");
      if (this.video && !this.closest(".video-carousel")) {
        this.init();
      }

      this.timeout = null;
    }

    init() {
      this.checkVideo();
      // In some cases Chrome fails to recognize the source initially - calling load forces it to re-check the src attribute.
      this.video.load();
      window.addEventListener("resize", () => {
        clearTimeout(this.timeout);
        setTimeout(() => {
          this.checkVideo();
        }, 200);
      });
    }

    checkVideo() {
      const isMobile = window.matchMedia(this.dataset.mediaQuery).matches;

      const src = this.video.dataset.mediaSrc;

      const mobileSrc =
        "mediaSrcMobile" in this.video.dataset
          ? this.video.dataset.mediaSrcMobile
          : src;

      const newSrc = isMobile ? mobileSrc : src;

      // Only update src if it has changed, to avoid flickering on resize
      if (newSrc !== this.video.src) {
        this.video.src = newSrc;
        this.video.load();
      }

      this.dataset.fillDirection = isMobile
        ? this.dataset.fillDirectionMobile
        : this.dataset.fillDirectionDesktop;
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
